<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-09 10:45:06

四种状态
 * @success
 * @danger
 * @warning
 * @default
--> 
<template>
    <div class="btnState">
        <div  v-if="row.other_status !== 200 && (tabName == '0' || tabName == '1')" >
            <p :class="{red: row.other_status === 300 || row.other_status === 201, defa: row.other_status === 202}" v-if="row.other_status === 300 || row.other_status === 201 || row.other_status === 202"><i class="el-icon-warning"></i><span class="ml-10">{{ row.other_status_desc }}</span></p>
            <div v-else :class="{success: row.other_status === 600, danger: row.other_status === 400, warning: row.other_status === 401, btnStyle: true }" >
                <p>{{ row.other_status_desc }}</p>
            </div>
        </div>
        <div v-if="tabName == '2'">
            <div :class="{warning: row.url_check_status == (linkStatus.toboUp || row.url_check_status == linkStatus.tobeCheck) && row.cooperate_status !== '3', default: row.url_check_status == linkStatus.finished || row.cooperate_status == '3', btnStyle: true }" >
                <p>{{ row.cooperate_status == '3' ? row.cooperate_status_desc : row.url_check_status_desc }}</p>
            </div>
        </div>
        <div v-if="tabName == '3'">
            <div :class="{success: row.cooperate_status == '1', default: row.cooperate_status == '2', btnStyle: true }" >
                <p>{{ row.cooperate_status_desc }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { linkStatus } from '@/utils/dataMap';

export default {
    props: {
        btnText: {
            type: String,
            default: () => ''
        },
        tabName: {
            type: String,
            default: () => '0'
        },
        row: {
            type: Object,
            default: () => {}
        }
    },
    name: "btnState",
    data() {
        return {
            linkStatus
        }
    },
    computed: {
        
    },
    methods: {
        
    }
}
</script>

<style lang="less" scoped>
.btnStyle {
    padding: 4px 8px;
    border-radius: 15px;
}
.success{
    background-color: #F5FFF6;
    color: @color-success;
}
.default{
    background-color: @background-color-base;
    color: @color-text-regular;
}
.warning{
    background-color: #FEF3E7;
    color: #FA8F14;
}
.danger{
    background-color: #FFEEED;
    color: @color-danger;
}
.red{
    font-size: 14px;
    color: @color-danger;
    margin-left: 12px;
}
.defa{
    color: @color-info;
    font-size: 14px;
    margin-left: 12px;
}
</style>
